import './style.scss'

import MainBanner from './MainBanner'
import SecondaryBanner from './SecondaryBanner'

type Images = {
  desktop: string
  tablet: string
  mobile: string
}

export type Banner = {
  backgroundColor: string
  title: {
    fontColor: string
    text: string
  }
  text: {
    fontColor: string
    body: string
  }
  priceContainer: {
    enable: boolean
    subtitlePrice: string
    price: string
    fontColor: string
  }
  cta: {
    enable: boolean
    text: string
    fontColor: string
    backgroundColor: string
  }
  linkURL: string
  images: {
    desktop: string
    tablet: string
    mobile: string
  }
}

export function renderImage(images: Images, screenWidth: number) {
  if (screenWidth > 1020) {
    return images?.desktop
  }

  if (screenWidth > 680 && screenWidth < 1020) {
    return images?.tablet
  }

  return images?.mobile
}

export default function PromotionBanner({
  title: titleSection,
  banners,
  fontColor,
  backgroundColor,
}: any) {
  const [mainBanner] = banners

  const secondaryBanner = [banners[1], banners[2]]

  return banners.length !== 3 ? null : (
    <section className="sectionPromotion" style={{ backgroundColor }}>
      <section className="containerPromotion">
        <h3 className="titleSectionPromotion" style={{ color: fontColor }}>
          {titleSection}
        </h3>
        <section className="containerBanners">
          <MainBanner mainBanner={mainBanner} />
          <SecondaryBanner secondaryBanner={secondaryBanner} />
        </section>
      </section>
    </section>
  )
}
